export default __webpack_public_path__ + "static/media/bgimage.e383b3c5.jpeg";